module.exports = __webpack_public_path__ + "static/media/team-2.dcfcf3b7.jpg";